export const TRANSLATIONS_FR = {
    header_menu_home:"Accueil",
    header_menu_schoolexamfees:"Frais Scolarite/Examen",
    header_menu_paymentschoolexamfees:"Paiement frais scolaires/examens",
    header_menu_paymentschoolexamfees_description:"Remplissez ce formulaire pour payer vos frais de scolarité ou d'examen",
    header_menu_findpayment:"Consulter paiement",
    consulter_paiement:"Consulter paiement",
    consulter_paiement_description:"Pour consulter les informations d'un paiement, veuillez entrer la référence et valider",
    header_menu_searchcode:"Rechercher code",
    header_menutop_espaceclient:"Espace client",
    header_menutop_assistance:"Assistance",
    header_menutop_pointvente:"Points de vente",
    header_menutop_business:"Business",
    header_menutop_particular:"Particulier",
    header_menu_followus:"Suivez-nous",
    header_menu_aboutocm:"A propos d'Orange Cameroun",
    header_menu_mentionlegal:"Mentions légales",
    header_menu_ocmfoundation:"Fondation Orange",
    page_welcome_paiementscolaritexamen:"Paiement Scolarité & Examen",
    page_welcome_feescolaritexamen:"Frais de Scolarité/Examen",
    page_welcome_payfeescolaritexamen:"Payer frais scolaire/Examen",
    page_welcome_feescolaritexamen_description:"Effectuer le paiement des frais de scolarité ou d'Examen des établissements",
    page_welcome_title_description:"Bienvenue sur le Portail de paiement des frais scolaire Orange Money.<br/>Accessible 7j/7 et 24h sur 24h depuis votre ordinateur, votre mobile ou votre tablette, cet espace dédié vous permet à tout moment d’effectuer vos opérations de paiement des frais scolaire en toute autonomie et sécurité.",
    header_menu_findapayment:"Consulter un paiement",
    header_menu_findapayment_description:"Consulter et imprimer des reçus de paiement des frais de scolarité/examen",
    header_menu_getschoolcode:"Obtenir un code établissement",
    header_menu_getschoolcode_cardtext:"Pour recherche un établissement, veuillez entrer le nom et valider",
    header_menu_getcode:"Obtenir code",
    header_menu_getschoolcode_description:"Rechercher les etablissements, leurs classes et examens disponibles",
    header_menu_getinfospaymenttuitionexam:"Obtenir des informations de paiement des frais scolaires",
    header_menu_getinfospaymenttuitionexam_description:"Vous avez payé vos frais de scolarité avec Orange Money. Merci de votre confiance.<br/><br/>Pour obtenir le reçu de votre paiement de frais scolaires",
    cliquerici:"cliquer ici",
    region:"Région",
    select_region:"Sélectionnez la région",
    select_departement:"Sélectionnez le département",
    select_arrondissement:"Sélectionnez l'arrondissement",
    departement:"Département",
    arrondissement:"Arrondissement",
    liste_etablissements:"Liste des établissements",
    noschool_toshow:"Aucun établissement à afficher pour le moment",
    goback_home:"Revenir à l'accueil",
    details_etablissement:"Détails établissement",
    etablissement:"Établissement",
    code:"Code",
    copier:"Copier",
    genre:"Genre",
    classes_disponible:"Classes disponibles",
    examens:"Examens",
    fermer:"Fermer",
    valider:"Valider",
    reference_payment:"Référence du paiement",
    feedback_reference_payment:"Veuillez renseigner la référence du paiement",
    impossible_tofindschoolinfos:"Impossible de recupérer les informations de l'établisseent.",
    entrer_reference_paiement:"Entrer le numéro de référence du paiement",
    imprimer:"Imprimer",
    montant:"Montant",
    produit_achete:"Produit acheté",
    id_transaction:"ID de la transaction",
    datepaiement:"Date de paiement",
    matricule:"Matricule",
    prenom:"Prénom",
    nom:"Nom",
    label_produit:"Produit",
    label_etablissement:"Établissement",
    label_examen:"Examen",
    label_classe:"Classe",
    label_fraisscolarite:"Frais de scolarité",
    label_fraisexamen:"Frais d'examen officiel",
    feedback_choisirproduit:"Veuillez choisir le produit",
    feedback_selectetablissement:"Veuillez sélectionner l'établissement",
    feedback_selectclasse:"Veuillez sélectionner la classe",
    feedback_selectexam:"Veuillez sélectionner l'examen",
    placeholder_nometablissement:"Entrez le nom de l'établissement",
    placeholder_referencepaiement:"Entrez la référence du paiement",
    placeholder_selectexam:"Sélectionnez l'examen",
    placeholder_selectclasse:"Sélectionnez la classe",
    label_studentlastname:"Nom de l'élève",
    label_studentfirstname:"Prénom de l'élève",
    label_studentbirthdate:"Date de naissance de l'élève",
    label_sexe:"Sexe",
    label_feminin:"Féminin",
    label_masculin:"Masculin",
    label_payer:"Payer",
    label_payerphonenumber:"Numéro de téléphone du payeur",
    label_parentphonenumber:"Numéro de téléphone du parent",
    label_noschoolfound:"Aucun établissement trouvé pour",
    placeholder_enterstudentlastname:"Entrez le nom de l'élève",
    feedback_enterstudentlastname:"Veuillez renseigner le nom de l'élève",
    placeholder_enterstudentfirstname:"Entrez le prénom de l'élève",
    placeholder_selectstudentbirthdate:"Sélectionnez la date de naissance de l'élève",
    placeholder_enterpayerphonenumber:"Entrez le numéro de téléphone du payeur",
    placeholder_enterparentphonenumber:"Entrez le numéro de téléphone du parent",
    feedback_enterstudentfirstname:"Veuillez renseigner le prénom de l'élève",
    feedback_selectstudentbirthdate:"Veuillez sélectionner la date de naissance de l'élève",
    feedback_selectsexe:"Veuillez sélectionner le sexe",
    feedback_enterpayerphonenumber:"Veuillez entrer le numéro de téléphone du payeur",
    feedback_enterparentphonenumber:"Veuillez entrer le numéro de téléphone du parent",
    servererror_savepayment:"Impossible d'enregistrer votre paiement. Veuillez réessayer plus tard",
    label_recapitulatifpaiement:"Récapitulatif paiement",
    label_pleasewait:"Veuillez patienter",
    label_frais:"Frais",
    label_amount:"Montant",
    confirmer:"Confirmer",
    label_requete_encourenregistrement:"Votre requête est en cours d'enregistrement. Veuillez s'il vous plait, ne pas quitter cette page",
    label_paiementenregistre:"Paiement enregistré",
    label_paiementenregistresucces:"Paiement enregistré avec succès",
    label_paiementfailed:"Échec Paiement",
    message_paymentsubmitted:"L’inscription de l’élève STUDENT_LASTNAME STUDENT_FIRSTNAME au SCHOOL_NAME pour un montant de PAYMENT_AMOUNT est en cours de traitement. Vous recevrez une confirmation par SMS sur le numéro PAYER_PHONE",
    erreur:"Erreur",
    recu_paiement:"Reçu Paiement",
    recu_paiementfrais:"Reçu de paiement des frais",
    label_date:"Date",
    reference_paiement:"Référence du paiement",
    service_indisponible:"Service indisponible. Veuillez réessayer plus tard",
    erreur_paiement:"Erreur paiement",
    echec_operation_veuillezreessayer:"Echéc de l'opération, veuillez réessayer plus tard.",
};
